import axios from "axios";
import { userServiceUrl } from "../Config/config";
import { toast, Slide } from "react-toastify";
import CustomToast from "../../Component/Toast";



let currentIndex = 0;

export const showToast = (message, type, customAutoCloseTime) => {
  if (!message) {
    console.log("No message provided.");
    return;
  }

  const displayMessage =
    typeof message === "string"
      ? message
      : message?.message || JSON.stringify(message);

  const messageArray = displayMessage.split(/[\.,\n]/).map(item => item.trim()).filter(item => item.length > 0);

  if (messageArray.length === 0) {
    console.log("No valid messages to show.");
    return;
  }

  const autoCloseDuration = customAutoCloseTime || 5000;



  if (currentIndex < messageArray.length) {
    const currentMessage = messageArray[currentIndex];

    const uniqueToastId = `toast-${Date.now()}-${Math.random()}`;

    toast(
      <CustomToast
        message={currentMessage}
        type={type}
        toastId={uniqueToastId}
        autoCloseTime={autoCloseDuration}
      />,
      {
        autoClose: autoCloseDuration,
        hideProgressBar: true,
        closeButton: false,
        toastId: uniqueToastId,
        transition: Slide,
      }
    );


    currentIndex++;
  }


  if (currentIndex >= messageArray.length) {

    currentIndex = 0;
  }
};

export const displayError = (error) => {
  toast.configure({
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: false,
  })
  if (error.response.status === 422) {
    // var row = [];
    // Object.keys(error.response.data.errors).forEach((key, i) => {
    //   row.push(error.response.data.errors[key][0]);
    // })
    // const Msg = ({ closeToast, toastProps }) => (
    //   row.map((char, i) => {
    //     return (
    //       <li>
    //         {char}
    //       </li>
    //     );
    //   })
    // )
    toast.error(error.response.data.message);
  } else if (error.response.status === 400 || error.response.status === 401) {
    toast.error(error.response.data.message);
  } else {
    toast.error(error.message);
  }
}


export const handleLogin = async ({ username, password }) => {
  try {
    const response = await axios.post(
      `${userServiceUrl}/provider/login`,
      { username, password },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};

export const handleUpdatepassword = async ({ current_password, password, confirm_password }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${userServiceUrl}/provider/update-password`,
      { current_password, password, confirm_password }, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const Authme = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${userServiceUrl}/provider/authme`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      window.localStorage.removeItem("token")
      setTimeout(() =>
        window.location.href = '/'
        , 1500)
    } else {
      return []
    }
  }
}

export const Dashboard = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${userServiceUrl}/provider/dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    });
    return response.data;
  } catch (error) {
    console.log(error.response.status, "////////")
    if (error.response.status == 401) {
      window.localStorage.removeItem("token")
      setTimeout(() =>
        window.location.href = '/'
        , 1500)
    } else {
      return []
    }
    // throw error.response ? error.response.data : error;
  }
}


export const Pastsession = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${userServiceUrl}/provider/past-sessions`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const Upcomingsession = async () => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${userServiceUrl}/provider/upcoming-sessions`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const Bookingsessiondetails = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${userServiceUrl}/provider/booking-session-details/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const handleStartsession = async ({ session_id, otp }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${userServiceUrl}/provider/start-session`,
      { session_id, otp },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const Initiatcompletesession = async (id) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.get(`${userServiceUrl}/provider/initiate-complete-session/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export const handleCompletesession = async ({ session_id, otp }) => {
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${userServiceUrl}/provider/complete-session`,
      { session_id, otp },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};

export const Getrating = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  try {
    const response = await axios.get(`${userServiceUrl}/provider/get-ratings`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};
export const markOnTheWay = async (id, lat, long) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  const data = {
    latitude: lat,
    longitude: long,
  }
  console.log(data,"p------Data")
  try {
    const response = await axios.post(`${userServiceUrl}/provider/mark-on-the-way/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};
export const sendLocation = async (id, lat, long) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  const data = {
    latitude: lat,
    longitude: long,
  }
  console.log(data,"--DATA------")
  try {
    const response = await axios.post(`${userServiceUrl}/provider/share-current-location/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};


export const getSurveyList = async (page, count, search) => {
  const data = {
    page: page,
    count: count,
    search: search
  }
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${userServiceUrl}/provider/survey-list`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const getSurveyDetails = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  try {
    const response = await axios.get(`${userServiceUrl}/provider/survey-details/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};


export const getSurveyCriteriaList = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  try {
    const response = await axios.get(`${userServiceUrl}/provider/survey-criteria-list/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

export const deleteCriteria = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  try {
    const response = await axios.get(`${userServiceUrl}/provider/delete-survey-criteria/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

export const getHospitalDashboard = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  try {
    const response = await axios.get(`${userServiceUrl}/provider/hospital-dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

export const getPastSurveyList = async (page, count, search) => {
  const data = {
    page: page,
    count: count,
    search: search
  }
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${userServiceUrl}/provider/past-surveys`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};

export const getTodaySurveyList = async (page, count, search) => {
  const data = {
    page: page,
    count: count,
    search: search
  }
  let token = localStorage.getItem("token")
  try {
    const response = await axios.post(
      `${userServiceUrl}/provider/today-surveys`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error.response ? error.response.data : error;
  }
};


export const getEarnings = async (page, count) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token is required");
  }
  const data = {
    page: page,
    count: count,
  }
  try {
    const response = await axios.post(`${userServiceUrl}/provider/get-earnings`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching ratings:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};